import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export function Impressum() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="border-b border-gray-100 py-4 px-6">
        <div className="max-w-4xl mx-auto flex items-center gap-4">
          <Link to="/" className="flex items-center gap-2 text-[#6B6B6B] hover:text-primary transition-colors">
            <ArrowLeft className="w-4 h-4" />
            <span>Zurück zur Startseite</span>
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-6 py-12">
        <h1 className="text-3xl font-bold text-[#1A1A1A] mb-8">Impressum</h1>

        <section className="prose prose-gray max-w-none space-y-6">
          <div>
            <h2 className="text-xl font-semibold text-[#1A1A1A] mb-3">Angaben gemäß § 5 TMG</h2>
            <p className="text-[#6B6B6B]">
              MAMAL GmbH<br />
              Musterstraße 1<br />
              12345 Musterstadt<br />
              Deutschland
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-[#1A1A1A] mb-3">Kontakt</h2>
            <p className="text-[#6B6B6B]">
              Telefon: +49 (0) 123 456789<br />
              E-Mail: <a href="mailto:kontakt@mamal.de" className="text-primary hover:underline">kontakt@mamal.de</a>
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-[#1A1A1A] mb-3">Handelsregister</h2>
            <p className="text-[#6B6B6B]">
              Registergericht: Amtsgericht Musterstadt<br />
              Registernummer: HRB 12345
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-[#1A1A1A] mb-3">Umsatzsteuer-ID</h2>
            <p className="text-[#6B6B6B]">
              Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
              DE 123456789
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-[#1A1A1A] mb-3">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
            <p className="text-[#6B6B6B]">
              Max Mustermann<br />
              Musterstraße 1<br />
              12345 Musterstadt
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-[#1A1A1A] mb-3">EU-Streitschlichtung</h2>
            <p className="text-[#6B6B6B]">
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{' '}
              <a
                href="https://ec.europa.eu/consumers/odr/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary hover:underline"
              >
                https://ec.europa.eu/consumers/odr/
              </a>
              <br />
              Unsere E-Mail-Adresse finden Sie oben im Impressum.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-[#1A1A1A] mb-3">Verbraucherstreitbeilegung / Universalschlichtungsstelle</h2>
            <p className="text-[#6B6B6B]">
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
              Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-[#1A1A1A] mb-3">Haftung für Inhalte</h2>
            <p className="text-[#6B6B6B]">
              Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den
              allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht
              verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu
              forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
            </p>
            <p className="text-[#6B6B6B] mt-2">
              Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen
              Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der
              Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden
              Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-[#1A1A1A] mb-3">Haftung für Links</h2>
            <p className="text-[#6B6B6B]">
              Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben.
              Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der
              verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-[#1A1A1A] mb-3">Urheberrecht</h2>
            <p className="text-[#6B6B6B]">
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen
              Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der
              Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
            </p>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="border-t border-gray-100 py-8 mt-12">
        <div className="max-w-4xl mx-auto px-6 flex flex-wrap gap-4 justify-center text-sm text-[#6B6B6B]">
          <Link to="/impressum" className="hover:text-primary transition-colors font-medium">Impressum</Link>
          <Link to="/datenschutz" className="hover:text-primary transition-colors">Datenschutz</Link>
          <Link to="/agb" className="hover:text-primary transition-colors">AGB</Link>
        </div>
      </footer>
    </div>
  );
}
